import { defineMessages } from 'react-intl';

export default defineMessages({
  label: {
    id: 'authenticator.onboarding.companySearchField.label',
    defaultMessage: 'Company name',
  },
  placeholder: {
    id: 'authenticator.onboarding.companySearchField.placeholder',
    defaultMessage: 'Type your company name',
  },
  searching: {
    id: 'authenticator.onboarding.companySearchField.searching',
    defaultMessage: 'Searching the public registers…',
  },
  noResult: {
    id: 'authenticator.onboarding.companySearchField.noResult',
    defaultMessage:
      'No company found. Keep typing your company name, you can enter it yourself.',
  },
  registerUnavailable: {
    id: 'authenticator.onboarding.companySearchField.registerUnavailable',
    defaultMessage:
      'The public registers are unavailable. Enter your company details yourself.',
  },
  inactiveCompany: {
    id: 'authenticator.onboarding.companySearchField.inactiveCompany',
    defaultMessage: 'Closed according to the register',
  },
  manualEntry: {
    id: 'authenticator.onboarding.companySearchField.manualEntry',
    defaultMessage: 'My company is not in the list: enter it manually',
  },
});
